import { injectIntl } from "react-intl";

import NavRight from "./NavRight";

export default injectIntl(NavRight);
